export const Keys = {
  Metadata: {
    Base: 'metadata',
    RefreshTime: 'refreshTime',
  },
}

export const Locations = {
  Metadata: {
    RefreshTime: (userUid: string) =>
      `${Keys.Metadata.Base}/${userUid}/${Keys.Metadata.RefreshTime}`,
  },
}
